module.exports = __webpack_public_path__ + "h5/img/cygn8.70e7f1c7.png";